
/*
 * Returns true if the input can be converted to a number, including numeric 0
 */
export const isNumeric = (s: string | number) => typeof s === 'number' && Number.isFinite(s) ||  
                                (typeof s === 'string' && s.trim() !== '' && Number.isFinite(Number(s)) );
/*
 * Returns true if the input can be converted to a positive number, including numeric 0.
 */
export const isPositiveNumeric = (s: string) => isNumeric(s) && parseInt(s, 10) > -1; 

/**
 * Return true if value is defined, including zero.
 */
export const isDefinedIncludingZero = (value: any) => !!value || value === 0;
